/* A manually controlled model rail: never moves while someone is choosing. */
if (!customElements.get('mr-navigation-rail')) {
  customElements.define('mr-navigation-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-nav-track]');
      if (!this.track) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.querySelectorAll('button').forEach(button => {
          button.hidden = max < 2;
          button.disabled = Number(button.dataset.direction) < 0 ? position < 2 : position >= max - 2;
        });
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * Number(button.dataset.direction) * this.track.clientWidth * .7,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.update();
      document.fonts?.ready.then(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}
